<template>
  <div class="apply-table">
    <a-table
      class="job-table"
      :rowKey="(record) => record.id"
      :columns="columns"
      bordered
      :data-source="data"
      :pagination="false"
    >
      <template v-slot:emptyText>
        <Empty />
      </template>
      <template v-slot:headerCell="{ title, column }">
        <template v-if="column.key === 'content'">
          <div style="text-align: center">{{ $t('user.' + title) }}</div>
          <!-- <div style="font-weight: initial !important">
            *The highlighted items show the key difference between this level
            and one level down.
          </div> -->
        </template>
        <!-- <template v-else-if="column.key === 'content'">
          <div style="text-align: center">{{ title }}</div>
        </template> -->
        <template v-else-if="column.key === 't_qualified'">
          <template v-if="status === 2">
            {{ $t('user.' + title) + '?' }}
            <a-tooltip>
              <template #title>
                {{
                  $t(
                    'user.Please leave comments on the qualification boxes which are not checked.'
                  )
                }}
              </template>
              <question-circle-filled />
            </a-tooltip>
          </template>
          <template v-else>{{ $t('user.' + title) }}</template>
        </template>
        <template v-else-if="column.key === 't_comments'">
          {{ $t('user.' + title) }}
          <a-tooltip v-if="status === 2">
            <template #title>
              {{ $t('user.Assess your employee and leave comments') }}
              <!-- Comments are mandatory if you do not check the “Qualified” box -->
            </template>
            <question-circle-filled />
          </a-tooltip>
        </template>
        <template v-else>
          {{ $t('user.' + title) }}
        </template>
      </template>

      <template v-slot:bodyCell="{ record, column }">
        <template v-if="column.key === 'e_qualified'">
          <div style="width: 100%; text-align: center">
            <template v-if="status === 1">
              <!-- 编辑 -->
              <a-checkbox
                v-model:checked="record[column.key]"
                @change="$emit('autoSave')"
                :disabled="disabled"
              ></a-checkbox>
            </template>
            <template v-else>
              <!-- 图标 -->
              <check-outlined
                style="color: #ac7f40; font-size: 18px"
                v-if="record[column.key] == true"
              />
              <a-checkbox
                v-else-if="
                  record[column.key] == false &&
                  (record['e_comments'] == '' || record['e_comments'] == null)
                "
                v-model:checked="record[column.key]"
                disabled
                @change="$emit('autoSave')"
              ></a-checkbox>
              <close-outlined style="color: #f44336; font-size: 18px" v-else />
            </template>
          </div>
        </template>
        <template v-else-if="column.key === 't_qualified'">
          <div style="width: 100%; text-align: center">
            <template v-if="status === 2">
              <!-- 编辑 -->
              <a-checkbox
                v-model:checked="record[column.key]"
                @change="$emit('autoSave')"
                :disabled="disabled"
              ></a-checkbox>
            </template>

            <template v-else>
              <!-- 图标 -->
              <check-outlined
                style="color: #ac7f40; font-size: 18px"
                v-if="record[column.key] == true"
              />
              <a-checkbox
                v-else-if="
                  record[column.key] != true &&
                  (record['t_comments'] == '' || record['t_comments'] == null)
                "
                v-model:checked="record[column.key]"
                disabled
                @change="$emit('autoSave')"
              ></a-checkbox>
              <close-outlined style="color: #f44336; font-size: 18px" v-else />
            </template>
          </div>
        </template>
        <CommentsEditor
          v-else-if="column.key === 'e_comments' || column.key === 't_comments'"
          :status="getCommentsStatus(column.key)"
          v-model:text="record[column.key]"
          :disabled="disabled"
          @autoSave="$emit('autoSave')"
        />
        <template v-else-if="column.key === 'content'">
          <div
            :style="`text-align:left;${
              record.style == 'high' ? 'color:#ac7f40' : ''
            }`"
          >
            {{ record.content }}
          </div>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import CommentsEditor from '@/components/CommentsEditor'
  import {
    QuestionCircleFilled,
    CloseOutlined,
    CheckOutlined,
  } from '@ant-design/icons-vue'
  // import 'remixicon/fonts/remixicon.css'
  import Empty from '@/components/Empty'

  export default {
    name: 'ApplyTable',
    props: {
      data: {
        type: Array,
        required: true,
      },
      status: {
        default: 0, //0=>只读 1=>e单编辑 2=>t单编辑 3=>编辑 4=>展示
        type: Number,
      },
      hideTips: {
        default: false,
        type: Boolean,
      },
      disabled: {
        default: false,
        type: Boolean,
      },
    },
    components: {
      CommentsEditor,
      CloseOutlined,
      CheckOutlined,
      QuestionCircleFilled,
      Empty,
    },
    data() {
      return {
        columns: [
          {
            title: 'Current Role Job Qualifications',
            key: 'content',
            width: 570,
            dataIndex: 'content',
          },
          {
            title: 'Employee',
            children: [
              {
                title: 'Qualified',
                key: 'e_qualified',
                dataIndex: 'e_qualified',
                width: 130,
              },
              {
                title: 'Comments',
                key: 'e_comments',
                width: 200,
                dataIndex: 'e_comments',
              },
            ],
          },
          {
            title: 'Review Manager',
            children: [
              {
                title: 'Qualified',
                key: 't_qualified',
                dataIndex: 't_qualified',
                width: 140,
              },
              {
                title: 'Comments',
                key: 't_comments',
                width: 200,
                dataIndex: 't_comments',
              },
            ],
          },
        ],
      }
    },

    computed: {},
    mounted() {
      console.log(this.data)
    },
    methods: {
      getCommentsStatus(field) {
        if (this.status === 3) {
          return 'edit'
        } else if (field === 'e_comments' && this.status == 1) {
          return 'edit'
        } else if (field === 't_comments' && this.status == 2) {
          return 'edit'
        } else {
          return 'view'
        }
      },
    },
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');

  .app-breadcrumb {
    background-color: white;
    padding: 12px 32px 12px 32px;
    font-size: 14px;
    color: #666666;
    .page-header {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 4px 0;
    }
    .page-remark {
      display: flex;
      align-items: center;
    }
    .page-title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 28px;
      font-weight: bold;
    }
  }
  .job-table {
    .ant-table-cell {
      text-align: center !important;
    }
  }
</style>
